export default __webpack_public_path__ + "static/media/LBMA_Norman_Accuracy.f524ffde.png";